var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-slider", class: { active: _vm.active } },
    [
      _c(
        "div",
        {
          staticClass: "toggle",
          class: { active: _vm.active },
          on: {
            click: function($event) {
              _vm.active = !_vm.active
            }
          }
        },
        [_c("span", [_vm._v(_vm._s(_vm.translations.title))])]
      ),
      _vm._v(" "),
      _c("form", [
        _c("span", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.translations.subtitle))
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("name") && _vm.submitted,
                expression: "errors.has('name') && submitted"
              }
            ],
            staticClass: "form-error"
          },
          [_vm._v(_vm._s(_vm.errors.first("name")))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.name,
              expression: "form.name"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          attrs: {
            id: "name",
            type: "text",
            name: "name",
            placeholder: _vm.translations.name
          },
          domProps: { value: _vm.form.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "name", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("email") && _vm.submitted,
                expression: "errors.has('email') && submitted"
              }
            ],
            staticClass: "form-error"
          },
          [_vm._v(_vm._s(_vm.errors.first("email")))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.email,
              expression: "form.email"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          attrs: {
            id: "email",
            type: "email",
            name: "email",
            placeholder: _vm.translations.email
          },
          domProps: { value: _vm.form.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "email", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("phone") && _vm.submitted,
                expression: "errors.has('phone') && submitted"
              }
            ],
            staticClass: "form-error"
          },
          [_vm._v(_vm._s(_vm.errors.first("phone")))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.phone,
              expression: "form.phone"
            }
          ],
          attrs: {
            id: "phone",
            type: "text",
            name: "phone",
            placeholder: _vm.translations.number
          },
          domProps: { value: _vm.form.phone },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "phone", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.message,
              expression: "form.message"
            }
          ],
          attrs: { placeholder: _vm.translations.message },
          domProps: { value: _vm.form.message },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "message", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("input", {
          attrs: {
            type: "hidden",
            id: "gclid_field",
            name: "gclid_field",
            value: ""
          }
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "hidden", id: "cid_field", name: "cid", value: "" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "terms" }, [
          _c("div", { staticClass: "checkbox-wrapper" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.agreed_terms.status,
                  expression: "agreed_terms.status"
                }
              ],
              attrs: { type: "checkbox", name: "conditions", id: "conditions" },
              domProps: {
                checked: Array.isArray(_vm.agreed_terms.status)
                  ? _vm._i(_vm.agreed_terms.status, null) > -1
                  : _vm.agreed_terms.status
              },
              on: {
                change: [
                  function($event) {
                    var $$a = _vm.agreed_terms.status,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.agreed_terms,
                            "status",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.agreed_terms,
                            "status",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.agreed_terms, "status", $$c)
                    }
                  },
                  function($event) {
                    _vm.agreed_terms.error = false
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c("a", { attrs: { target: "_blank", href: _vm.terms } }, [
              _vm._v(
                "\n          " +
                  _vm._s(this.$translations.cart.terms_text) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _vm.agreed_terms.error && !_vm.agreed_terms.status
            ? _c("div", { staticClass: "form-error" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(this.$translations.cart.terms_error) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            class: { "btn-loading": _vm.loading },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.submit($event)
              }
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.translations.send) + "\n    ")]
        )
      ]),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "form-error" }, [
            _vm._v("\n    " + _vm._s(this.$translations.form.error) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.success
        ? _c("div", { staticClass: "form-success" }, [
            _vm._v(
              "\n    " + _vm._s(this.$translations.form.post_success) + "\n  "
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }